export type CommonFormField = {
  id: string;
  label: string;
  placeholder?: string;
  disclaimer?: string;
};

export type CommonValidationRules = {
  required?: boolean;
  requiredMessage?: string;
};

export const commonFormFieldId = [
  {
    name: "id",
    type: "string",
    defaultValue: "sample-id",
    required: true,
  },
] as const satisfies Inputs;

export const commonFormFields = [
  ...commonFormFieldId,
  {
    name: "label",
    type: "string",
    defaultValue: "Form input label",
    required: true,
  },
  {
    name: "placeholder",
    defaultValue: "Form input placeholder",
    type: "string",
  },
  {
    name: "disclaimer",
    type: "string",
  },
] as const satisfies Inputs;

export const commonValidationRules = [
  {
    name: "required",
    type: "boolean",
  },
  {
    name: "requiredMessage",
    defaultValue: "This field is required",
    type: "string",
  },
] as const satisfies Inputs;
